import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markAllNotificationsRead, markNotificationRead } from '../api/notifications.api';
import { notificationsKeys } from './notifications.keys';

/** Mark-read mutations for the notification bell (MYN-55). */
export function useNotificationActions() {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey: notificationsKeys.all });

  const markRead = useMutation({
    mutationFn: (id: string) => markNotificationRead(id),
    onSuccess: () => void invalidate(),
  });

  const markAllRead = useMutation({
    mutationFn: () => markAllNotificationsRead(),
    onSuccess: () => void invalidate(),
  });

  return { markRead, markAllRead };
}
